import _ from 'lodash';

export const getTypingUsers = state => state.typing;
export const getTypingUserIds = state => _.map(getTypingUsers(state), user => user._id);
